import { AfterViewInit, ChangeDetectorRef, Component, computed, DestroyRef, effect, HostListener, inject, Injector, OnDestroy, OnInit, signal, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AgGridAngular, AgGridModule } from 'ag-grid-angular';
import { CellClassParams, ColDef, EditableCallbackParams, GetContextMenuItemsParams, GetRowIdFunc, GetRowIdParams, GridOptions, ICellRendererParams, IServerSideDatasource, NewValueParams, RowClickedEvent, RowSelectedEvent, RowSelectionOptions, SELECTION_COLUMN_ID, SelectionChangedEvent, SelectionColumnDef, SideBarDef, StatusPanelDef, ValueFormatterParams } from 'ag-grid-community';
import { ReplaySubject, Subscription } from 'rxjs';
import { ColumnConfigItem } from '../../../models/column-config-item';
import { FilterSelectItem } from '../../../models/filter-select-item';
import { DiagnosisEventItem } from '../../../models/diagnosis-event-item';
import { ToggleItem } from '../../../models/toggle-item';
import { DiagnosisEventService } from '../../../services/diagnosis-event/diagnosis-event.service';
import { SettingsKeys, SettingsService } from '../../../services/settings/settings.service';
import { EditIconRendererComponent } from '../../ag-grid-components/edit-icon-renderer/edit-icon-renderer.component';
import { PayerSelectComponent } from '../../field-components/payer-select/payer-select.component';
import { PreferredActionSelectComponent } from '../../field-components/preferred-action-select/preferred-action-select.component';
import { RootCauseSelectComponent } from '../../field-components/root-cause-select/root-cause-select.component';
import { StatusSelectComponent } from '../../field-components/status-select/status-select.component';
import { StatusStateSelectComponent } from '../../field-components/status-state-select/status-state-select.component';
import { UserSearchByPermissionComponent } from '../../field-components/user-search-by-permission/user-search-by-permission.component';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatDialog } from '@angular/material/dialog';
import { AssignOpptyDialogComponent, AssignOpptyDialogModel } from '../../../dialogs/assign-oppty-dialog/assign-oppty-dialog.component';
import { DiagnosisEventQuery, QueryDateRange } from '../../../models/diagnosis-event-query';
import { DosSelectComponent } from '../../field-components/dos-select/dos-select.component';
import { EditOpptyDialogComponent, EditOpptyDialogData, EditOpptyDialogModel } from '../../../dialogs/edit-oppty-dialog/edit-oppty-dialog.component';
import { StringFormatter } from '../../../helpers/string-formatter';
import { DiagnosisEventType } from '../../../models/diagnosis-event-type';
import { DateQuarter } from '../../../models/date-quarter';
import { NotesRendererComponent } from '../../ag-grid-components/notes-renderer/notes-renderer.component';
import { DiagnosisEventNotesDialogComponent, DiagnosisEventNotesDialogModel } from '../../../dialogs/diagnosis-event-notes-dialog/diagnosis-event-notes-dialog.component';
import { ProgressAllocationUserComponent } from '../../sub-components/progress-allocation-user/progress-allocation-user.component';
import { AgPaginatorComponent, IAgPaginator } from '../../ag-grid-components/ag-paginator/ag-paginator.component';
import { AgAssignButtonComponent, IAgAssignButton } from '../../ag-grid-components/ag-assign-button/ag-assign-button.component';
import { AgExportButtonComponent, IAgExportButton } from '../../ag-grid-components/ag-export-button/ag-export-button.component';
import { DiagnosisEventFilterValues } from '../../../models/diagnosis-event-filter-values';
import { PermissionMap, PermissionService } from '../../../services/settings/permission.service';
import { Permission } from '../../../models/permission';
import { UserService } from '../../../services/user/user.service';
import { User } from '../../../models/user.model';
import { QueryMetadata, QuerySort } from '../../../models/query-metadata';
import { ExportService } from '../../../services/files/export.service';
import { AgNoRowsOverlayComponent } from '../../ag-grid-components/ag-no-rows-overlay/ag-no-rows-overlay.component';
import { AgRowSelectedCountComponent, IAgRowSelectedCount } from '../../ag-grid-components/ag-row-selected-count/ag-row-selected-count.component';
import { AgOpptyEditButtonComponent, IAgOpptyEditButton } from '../../ag-grid-components/ag-oppty-edit-button/ag-oppty-edit-button.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AgHeaderCheckboxComponent } from '../../ag-grid-components/ag-header-checkbox/ag-header-checkbox.component';
import { Comparitors } from '../../../helpers/comparitors';
import { ListMenuOption } from '../../../models/list-menu-option';
import { formatDate, NgClass } from '@angular/common';
import { FieldFilterService } from '../../../services/filters/field-filter.service';
import { FilterFieldSearchSelectComponent } from '../../field-components/filter-field-search-select/filter-field-search-select.component';
import { TemplateService } from '../../../services/settings/template.service';
import { TemplateConfigFieldItem } from '../../../models/template-config-field-item';
import { PreferredActionType } from '../../../models/preferred-action-type';
import { MatSelectionList, MatListOption } from '@angular/material/list';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { ProgressAllocationTotalsComponent } from '../../sub-components/progress-allocation-totals/progress-allocation-totals.component';
import { ProgressAllocationPreferredActionComponent } from '../../sub-components/progress-allocation-preferred-action/progress-allocation-preferred-action.component';
import { ProgressAllocationPayerComponent } from '../../sub-components/progress-allocation-payer/progress-allocation-payer.component';
import { MatChipListbox, MatChipOption } from '@angular/material/chips';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import _ from 'lodash';
import { AppStore } from '../../../store/app.store';
import { OpportunityListStore } from '../../../store/opportunity-list.store';
import { HccHyperlinkRendererComponent } from './hcc-hyperlink-renderer/hcc-hyperlink-renderer.component';
import { ASM_FILE_GEN_AND_SUB_CONFIG, AsmFileGenerationAndSubmissionComponent, AsmFileGenerationAndSubmissionModel } from '../../../dialogs/asm-file-generation-and-submission/asm-file-generation-and-submission.component';
import { LocalDateTimeHelper } from '../../../helpers/local-date-time-helper';
import { AsmFileUpdateRequest } from '../../../models/asm-file-update-request';
import { OkDialogComponent, OkDialogModel } from '../../../dialogs/ok-dialog/ok-dialog.component';
import { MatCheckbox } from '@angular/material/checkbox';

@Component({
    selector: 'app-opportunity-list-page',
    templateUrl: './opportunity-list-page.component.html',
    styleUrls: ['./opportunity-list-page.component.scss'],
    imports: [
        NgClass,
        MatSelectionList,
        MatListOption,
        MatTooltip,
        MatIcon,
        ProgressAllocationTotalsComponent,
        ProgressAllocationUserComponent,
        ProgressAllocationPreferredActionComponent,
        ProgressAllocationPayerComponent,
        MatChipListbox,
        MatChipOption,
        PreferredActionSelectComponent,
        PayerSelectComponent,
        StatusStateSelectComponent,
        StatusSelectComponent,
        RootCauseSelectComponent,
        UserSearchByPermissionComponent,
        MatFormField,
        MatLabel,
        MatInput,
        FormsModule,
        ReactiveFormsModule,
        MatError,
        DosSelectComponent,
        MatButton,
        AgGridModule,
        FilterFieldSearchSelectComponent,
        MatCheckbox
    ],
    providers: [OpportunityListStore]
})
export class OpportunityListPageComponent implements OnInit, AfterViewInit, OnDestroy {

  mode = 'oppty-list';
  sideMenuCollapsed = false;
  defaultChipSelection: string | null = null;
  currentChipSelection: string | null = '';
  isDosFilterToggled = false;
  defaultUser: string | null = null;
  defaultPayer: string | null = null;

  isGridReady = false;
  isPreferredActionReady = false;
  isPayerReady = false;
  isStatusStateReady = false;
  isStatusReady = false;
  isRootCauseReady = false;
  isPaymentYearReady = false;
  isAssignedReady = false;
  isDosReady = false;

  formValid = false;
  canQuickFilterUnselect = false;
  isFirstGenerate = true;

  currentUser?: User;
  activeUserPerms?: Permission[];
  editAllActive = false;
  assignToActive = false;
  exportActive = false;
  currentListSize = 0;
  batchEditLimit = 300;
  allSelected = new ReplaySubject<boolean>(1);
  allBatchEditEnabled = false;
  allSamePreferredActionFromServer = false;

  paTypeIDs = [PreferredActionType.Opportunity.valueOf()];

  currentPageRows: string[] = [];

  exportTooltip = 'Export Opportunities';

  opptyFilterChips: ToggleItem[] = [
    {Name: "Master", DisplayName: "Master", Selected: false},
    {Name: "99499", DisplayName: "99499", Selected: false},
    {Name: "ASM", DisplayName: "ASM", Selected: false},
    {Name: "Research EMR", DisplayName: "Research EMR", Selected: false}
  ];

  dxFilterChips: ToggleItem[] = [
    {Name: "Payer Validation", DisplayName: "Payer Validation", Selected: false},
    {Name: "Non-Actionable", DisplayName: "Non-Actionable", Selected: false}
  ];

  menuOptions: ListMenuOption[] = [
    {ID: 1, Name: "Allocation", Icon: "content_paste", IconOutlined: false, Disabled: false},
    {ID: 2, Name: "Users", Icon: "group", IconOutlined: false, Disabled: false},
    {ID: 3, Name: "Preferred Actions", Icon: "analytics", IconOutlined: true, Disabled: false},
    {ID: 4, Name: "Top Payers", Icon: "paid", IconOutlined: true, Disabled: false}
  ];

  frameworkComps = {
    editRenderer: EditIconRendererComponent,
    notesRenderer: NotesRendererComponent,
  }

  sideBar: SideBarDef | string | string[] | boolean | null = {
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
        toolPanelParams: {
          suppressRowGroups: true,
          suppressValues: true,
          suppressPivots: true,
          suppressPivotMode: true,
          suppressColumnExpandAll: true
        }
      },
    ]
  };

  statusBar: {
    statusPanels: StatusPanelDef[];
  } = {
    statusPanels: [
      {
        statusPanel: AgRowSelectedCountComponent,
        key: 'row-selected-count',
        align: 'left'
      },
      {
        statusPanel: AgAssignButtonComponent,
        key: 'assign-btn',
        align: 'left'
      },
      {
        statusPanel: AgOpptyEditButtonComponent,
        key: 'edit-btn',
        align: 'left'
      },
      {
        statusPanel: AgPaginatorComponent,
        key: 'ag-paginator'
      },
      {
        statusPanel: AgExportButtonComponent,
        key: 'export-btn'
      },
    ],
  };

  noRowsOverlayComponent: any = AgNoRowsOverlayComponent;
  noRowsOverlayComponentParams: any = {
    noRowsMessageFunc: () => 'No results returned',
  };

  // Row checkboxes live in AG Grid's selection column (colId SELECTION_COLUMN_ID); the custom header handles page-level select all.
  rowSelection: RowSelectionOptions = { mode: 'multiRow', checkboxes: true, headerCheckbox: false, enableClickSelection: false, copySelectedRows: false };
  selectionColumnDef: SelectionColumnDef = { headerComponent: AgHeaderCheckboxComponent, headerClass: 'no-left-padding',
    minWidth: 40, maxWidth: 40, pinned: 'left', sortable: false, suppressMovable: true };

  editColDef: ColDef = { 
    colId: 'edit', headerName: 'Edit', minWidth: 68, maxWidth: 68, suppressColumnsToolPanel: true, 
    pinned: 'right', cellRenderer: 'editRenderer', sortable: false 
  };

  expandColDef: ColDef = { colId: 'expand', cellRenderer: 'agGroupCellRenderer',
    suppressColumnsToolPanel: true, minWidth: 40, maxWidth: 40, pinned: 'left', sortable: false, suppressMovable: true };

  // ASM record type values sent to/received from the API ('A' = Add, 'D' = Delete; null = Add)
  asmRecordTypeOptions: Record<string, string> = { A: 'Add', D: 'Delete' };

  // Always displayed, pinned right to the left of Edit. Dropdown only shown when the row's EnableEditASMType flag is set (AcceptsASMDelete + ASM Preferred Action, computed by the proc).
  asmRecordTypeColDef: ColDef = {
    colId: 'ASMRecordType',
    field: 'ASMRecordType',
    headerName: 'ASM Add/Delete',
    headerTooltip: 'ASM Add/Delete',
    minWidth: 120,
    maxWidth: 120,
    pinned: 'right',
    lockPinned: true,
    suppressMovable: true,
    suppressColumnsToolPanel: true,
    singleClickEdit: true,
    editable: (params: EditableCallbackParams) => this.canEditAsmRecordType(params.data),
    // Rich select opens its list as soon as editing starts (agSelectCellEditor only does so when started via Enter)
    cellEditor: 'agRichSelectCellEditor',
    cellEditorParams: { values: ['A', 'D'] },
    valueFormatter: (params: ValueFormatterParams) => {
      // The select editor formats its options without row data
      if (params.data && !this.showsAsmRecordType(params.data)) {
        return '';
      }

      return this.asmRecordTypeOptions[params.value ?? 'A'] ?? '';
    },
    cellRenderer: (params: ICellRendererParams) => params.valueFormatted ? `${params.valueFormatted} &#9662;` : '',
    cellStyle: (params: CellClassParams) => {
      if (this.showsAsmRecordType(params.data) && this.isAsmModeEnabled()) {
        return { opacity: '0.3', cursor: 'default' };
      }

      return { opacity: '1', cursor: this.canEditAsmRecordType(params.data) ? 'pointer' : 'default' };
    },
    onCellValueChanged: (params: NewValueParams) => this.onAsmRecordTypeChanged(params),
  };

  opptyColumnDefs: ColDef[] = [
    {
      colId: 'expand',
      cellRenderer: 'agGroupCellRenderer',
      suppressColumnsToolPanel: true,
      minWidth: 40,
      maxWidth: 40,
      pinned: 'left',
      lockPinned: true,
      sortable: false,
      suppressMovable: true,
      cellRendererParams: {
        suppressCount: true,
        suppressDoubleClickExpand: true,
        suppressEnterExpand: true
      }
    },

    { field: 'ID', headerName: 'ID', headerTooltip: 'ID' },
    { field: 'EventTypeName', headerName: 'Event Type', headerTooltip: 'Event Type' },
    { field: 'Status', headerName: 'Status', headerTooltip: 'Status', valueFormatter: this.filterOptionValue },
    { field: 'TargetedHCC', headerName: 'Targeted Event', headerTooltip: 'Targeted Event', valueFormatter: (item: any) => { return item.value === 1 ? 'Yes' : 'No' } },
    { field: 'Payer', headerName: 'Payer', headerTooltip: 'Payer', minWidth: 100, valueFormatter: this.payerValue, tooltip: this.payerTooltip },
    { field: 'AssignedTo', headerName: 'Assigned User', headerTooltip: 'Assigned User', minWidth: 150, valueFormatter: this.assignedUserValue, tooltip: this.assingedUserTooltip },
    { field: 'EMRPID', headerName: 'EMR PID', type: 'numericColumn', headerTooltip: 'EMR Patient ID' },
    { field: 'DateOfService', headerName: 'DOS', type: 'numericColumn', headerTooltip: 'DOS' },
    { field: 'ServiceLocation', headerName: 'Service Location', headerTooltip: 'Service Location', tooltip: this.tooltipValue },
    { field: 'VisitID', headerName: 'Visit ID', type: 'numericColumn', headerTooltip: 'Visit ID' },
    { field: 'ICDCODE', headerName: 'ICD10', type: 'numericColumn', headerTooltip: 'ICD10' },
    { field: 'PreferredAction', headerName: 'Preferred Action', headerTooltip: 'Preferred Action', minWidth: 150, valueFormatter: this.filterOptionValue },
    { field: 'RootCause', headerName: 'Root Cause', headerTooltip: 'Root Cause', minWidth: 150, valueFormatter: this.filterOptionValue , tooltip: this.filterTooltipValue },
    { field: 'Notes', headerName: 'Notes', headerTooltip: 'Notes', minWidth: 150, cellRenderer: 'notesRenderer'},
    { field: 'StatusState', headerName: 'Status State', headerTooltip: 'Status State', valueFormatter: this.filterOptionValue },
    { field: 'SuperbillStatus', headerName: 'Superbill Status', headerTooltip: 'Superbill Status' },
    { field: 'HCCCode', headerName: 'CMS HCC', type: 'numericColumn', headerTooltip: 'CMS HCC'},
    { field: 'BillingChargePostingDate', headerName: 'Billing Charges Posting Date', type: 'numericColumn', headerTooltip: 'Billing Charges Posting Date' },
    { field: 'EMRDocumentVersion', headerName: 'Doc. Version', headerTooltip: 'Doc. Version' },
    { field: 'EMRDocumentVersionCreateDate', headerName: 'Doc. Create Date', type: 'numericColumn', headerTooltip: 'Doc. Create Date' },
    { field: 'PatientFirstName', headerName: 'Patient First Name', headerTooltip: 'Patient First Name' },
    { field: 'PatientLastName', headerName: 'Patient Last Name', headerTooltip: 'Patient Last Name' },
    { field: 'PatientDateOfBirth', headerName: 'Patient DOB', type: 'numericColumn', headerTooltip: 'Patient DOB' },
    { field: 'PaymentYear', headerName: 'Payment Year', type: 'numericColumn', headerTooltip: 'Payment Year' },
    { field: 'BillingPaymentPostingDate', headerName: 'Billing Payment Posting Date', headerTooltip: 'Billing Payment Posting Date', type: 'numericColumn', minWidth: 100 },
    { field: 'IsOnSupplementalFeed', headerName: 'On ASM', headerTooltip: 'On ASM', valueFormatter: this.booleanValue },
    { field: 'IsDocumentInEMR', headerName: 'Is Doc In EMR', headerTooltip: 'Is Document In EMR', valueFormatter: this.booleanValue },
    { field: 'LastModifiedBy', headerName: 'Last Modified By', headerTooltip: 'Last Modified By', minWidth: 150, valueFormatter: this.assignedUserValue, tooltip: this.assingedUserTooltip },
    { field: 'LastModifiedDateTime', headerName: 'Last Modified Date', headerTooltip: 'Last Modified Date', minWidth: 150},
    { field: 'CreatedDateTime', headerName: 'Event Create Date', headerTooltip: 'Event', minWidth: 125},
    { field: 'CCN', headerName: 'CCN', type: 'numericColumn', headerTooltip: 'CCN' },
    { field: 'PatientMiddleName', headerName: 'Patient Middle Name', headerTooltip: 'Patient Middle Name' },
    { field: 'PatientSuffix', headerName: 'Patient Suffix', headerTooltip: 'Patient Suffix' },
    { field: 'PatientAddress1', headerName: 'Patient Address 1', headerTooltip: 'Patient Address 1' },
    { field: 'PatientAddress2', headerName: 'Patient Address 2', headerTooltip: 'Patient Address 2' },
    { field: 'PatientAddressCity', headerName: 'Patient Address City', headerTooltip: 'Patient Address City' },
    { field: 'PatientAddressState', headerName: 'Patient Address State', headerTooltip: 'Patient Address State' },
    { field: 'PatientAddressCode', headerName: 'Patient Address Code', headerTooltip: 'Patient Address Code' },
    { field: 'PatientGender', headerName: 'Patient Gender', headerTooltip: 'Patient Gender' },
    { field: 'PatientPCPFirstName', headerName: 'Patient PCP First Name', headerTooltip: 'Patient PCP First Name' },
    { field: 'PatientPCPLastName', headerName: 'Patient PCP Last Name', headerTooltip: 'Patient PCP Last Name' },
    { field: 'RenderingProviderFirstName', headerName: 'Rendering Provider First Name', headerTooltip: 'Rendering Provider First Name' },
    { field: 'RenderingProviderLastName', headerName: 'Rendering Provider Last Name', headerTooltip: 'Rendering Provider Last Name' },
    { field: 'RenderingProviderNPI', headerName: 'Rendering Provider NPI', headerTooltip: 'Rendering Provider NPI' },
    { field: 'RenderingProviderTaxID', headerName: 'Rendering Provider Tax ID', headerTooltip: 'Rendering Provider Tax ID' },
    { field: 'RenderingProviderTaxonomyCode', headerName: 'Rendering Provider Taxonomy Code', headerTooltip: 'Rendering Provider Taxonomy Code' },
    { field: 'RiskAdjustableCPT', headerName: 'RA CPT', headerTooltip: 'Risk Adjustable CPT' },
    { field: 'PlaceOfService', headerName: 'PlaceOfService', headerTooltip: 'PlaceOfService' },
    { field: 'RCMPID', headerName: 'RCM PID', headerTooltip: 'RCM PID' },
    { field: 'BillableProviderNPI', headerName: 'Billable Provider NPI', headerTooltip: 'Billable Provider NPI' },
    { field: 'BillableProviderName', headerName: 'Billable Provider Name', headerTooltip: 'Billable Provider Name' },
    { field: 'PatientDeceasedDate', headerName: 'Patient Deceased Date', headerTooltip: 'Patient Deceased Date' },
    { field: 'MBI', headerName: 'MBI', headerTooltip: 'MBI' },
    { field: 'PatientPolicyID', headerName: 'Patient Policy ID', headerTooltip: 'Patient Policy ID' },
    { field: 'IcdOnClaim', headerName: 'ICD on Claim', headerTooltip: 'ICD on Claim' },
    { field: 'PatientOnMAO', headerName: 'Patient on MAO', headerTooltip: 'Patient on MAO', valueFormatter: this.booleanValue },
    { field: 'DxOnMAO', headerName: 'ICD on MAO', headerTooltip: 'ICD on MAO', valueFormatter: this.booleanValue },
    { field: 'MAOStatus', headerName: 'MAO04 Status', headerTooltip: 'MAO04 Status' },
    { field: 'CurrentDate', headerName: 'Current Date', headerTooltip: 'Current Date' },
    { field: 'ClaimID', headerName: 'Claim ID', headerTooltip: 'Claim ID' },
    { field: 'FacilityName', headerName: 'Facility Name', headerTooltip: 'Facility Name' },
    { field: 'ClaimNumber', headerName: 'Claim Number', headerTooltip: 'Claim Number' },
    { field: 'ClaimType', headerName: 'Claim Type', headerTooltip: 'Claim Type' },
    { field: 'TOBCode', headerName: 'Type of Bill', headerTooltip: 'Type of Bill' },
    { field: 'RevenueCode', headerName: 'Revenue Code', headerTooltip: 'Revenue Code' },
    { field: 'PayerSubmissionDeadline', headerName: 'Payer Submission Deadline', headerTooltip: 'Payer Submission Deadline' },
    { field: 'DaysInStatus', headerName: 'Days In Status', headerTooltip: 'Days In Status' },
    { field: 'MAOCount', headerName: 'MAO04 Count', headerTooltip: 'MAO04 Count', type: 'numericColumn' },

    this.asmRecordTypeColDef,
    { colId: 'edit', headerName: 'Edit', minWidth: 68, maxWidth: 68, suppressColumnsToolPanel: true,
    pinned: 'right', cellRenderer: 'editRenderer', sortable: false },
  ];

  dxColumnDefs: ColDef[] = [
     {
      colId: 'expand',
      cellRenderer: 'agGroupCellRenderer',
      suppressColumnsToolPanel: true,
      minWidth: 40,
      maxWidth: 40,
      pinned: 'left',
      lockPinned: true,
      sortable: false,
      suppressMovable: true,
      cellRendererParams: {
        suppressCount: true,
        suppressDoubleClickExpand: true,
        suppressEnterExpand: true
      }
    },

    { field: 'ID', headerName: 'ID', headerTooltip: 'ID' },
    { field: 'EventTypeName', headerName: 'Event Type', headerTooltip: 'Event Type' },
    { field: 'Status', headerName: 'Status', headerTooltip: 'Status', valueFormatter: this.filterOptionValue },
    { field: 'TargetedHCC', headerName: 'Targeted Event', headerTooltip: 'Targeted Event', valueFormatter: (item: any) => { return item.value === 1 ? 'Yes' : 'No' } },
    { field: 'Payer', headerName: 'Payer', headerTooltip: 'Payer', minWidth: 150, valueFormatter: this.payerValue, tooltip: this.payerTooltip },
    { field: 'AssignedTo', headerName: 'Assigned User', headerTooltip: 'Assigned User', minWidth: 150, valueFormatter: this.assignedUserValue, tooltip: this.assingedUserTooltip },
    { field: 'EMRPID', headerName: 'EMR PID', type: 'numericColumn', headerTooltip: 'EMR Patient ID' },
    { field: 'DateOfService', headerName: 'DOS', type: 'numericColumn', headerTooltip: 'DOS' },
    { field: 'ServiceLocation', headerName: 'Service Location', headerTooltip: 'Service Location', tooltip: this.tooltipValue },
    { field: 'VisitID', headerName: 'Visit ID', type: 'numericColumn', headerTooltip: 'Visit ID' },
    { field: 'ICDCODE', headerName: 'ICD10', type: 'numericColumn', headerTooltip: 'ICD10' },
    { field: 'PreferredAction', headerName: 'Preferred Action', headerTooltip: 'Preferred Action', minWidth: 150, valueFormatter: this.filterOptionValue },
    { field: 'RootCause', headerName: 'Root Cause', headerTooltip: 'Root Cause', minWidth: 150, valueFormatter: this.filterOptionValue , tooltip: this.filterTooltipValue },
    { field: 'Notes', headerName: 'Notes', headerTooltip: 'Notes', minWidth: 150, cellRenderer: 'notesRenderer'},
    { field: 'StatusState', headerName: 'Status State', headerTooltip: 'Status State', valueFormatter: this.filterOptionValue },
    { field: 'SuperbillStatus', headerName: 'Superbill Status', headerTooltip: 'Superbill Status' },
    { field: 'HCCCode', headerName: 'CMS HCC', type: 'numericColumn', headerTooltip: 'CMS HCC'},
    { field: 'BillingChargePostingDate', headerName: 'Billing Charges Posting Date', type: 'numericColumn', headerTooltip: 'Billing Charges Posting Date' },
    { field: 'EMRDocumentVersion', headerName: 'Doc. Version', headerTooltip: 'Doc. Version' },
    { field: 'EMRDocumentVersionCreateDate', headerName: 'Doc. Create Date', type: 'numericColumn', headerTooltip: 'Doc. Create Date' },
    { field: 'PatientFirstName', headerName: 'Patient First Name', headerTooltip: 'Patient First Name' },
    { field: 'PatientLastName', headerName: 'Patient Last Name', headerTooltip: 'Patient Last Name' },
    { field: 'PatientDateOfBirth', headerName: 'Patient DOB', type: 'numericColumn', headerTooltip: 'Patient DOB' },
    { field: 'PaymentYear', headerName: 'Payment Year', type: 'numericColumn', headerTooltip: 'Payment Year' },
    { field: 'BillingPaymentPostingDate', headerName: 'Billing Payment Posting Date', headerTooltip: 'Billing Payment Posting Date', type: 'numericColumn', minWidth: 100 },
    { field: 'IsOnSupplementalFeed', headerName: 'On ASM', headerTooltip: 'On ASM', valueFormatter: this.booleanValue },
    { field: 'IsDocumentInEMR', headerName: 'Is Doc In EMR', headerTooltip: 'Is Document In EMR', valueFormatter: this.booleanValue },
    { field: 'LastModifiedBy', headerName: 'Last Modified By', headerTooltip: 'Last Modified By', minWidth: 150, valueFormatter: this.assignedUserValue, tooltip: this.assingedUserTooltip },
    { field: 'LastModifiedDateTime', headerName: 'Last Modified Date', headerTooltip: 'Last Modified Date', minWidth: 150},
    { field: 'CreatedDateTime', headerName: 'Event Create Date', headerTooltip: 'Event', minWidth: 150},
    { field: 'CCN', headerName: 'CCN', type: 'numericColumn', headerTooltip: 'CCN' },
    { field: 'PatientMiddleName', headerName: 'Patient Middle Name', headerTooltip: 'Patient Middle Name' },
    { field: 'PatientSuffix', headerName: 'Patient Suffix', headerTooltip: 'Patient Suffix' },
    { field: 'PatientAddress1', headerName: 'Patient Address 1', headerTooltip: 'Patient Address 1' },
    { field: 'PatientAddress2', headerName: 'Patient Address 2', headerTooltip: 'Patient Address 2' },
    { field: 'PatientAddressCity', headerName: 'Patient Address City', headerTooltip: 'Patient Address City' },
    { field: 'PatientAddressState', headerName: 'Patient Address State', headerTooltip: 'Patient Address State' },
    { field: 'PatientAddressCode', headerName: 'Patient Address Code', headerTooltip: 'Patient Address Code' },
    { field: 'PatientGender', headerName: 'Patient Gender', headerTooltip: 'Patient Gender' },
    { field: 'PatientPCPFirstName', headerName: 'Patient PCP First Name', headerTooltip: 'Patient PCP First Name' },
    { field: 'PatientPCPLastName', headerName: 'Patient PCP Last Name', headerTooltip: 'Patient PCP Last Name' },
    { field: 'RenderingProviderFirstName', headerName: 'Rendering Provider First Name', headerTooltip: 'Rendering Provider First Name' },
    { field: 'RenderingProviderLastName', headerName: 'Rendering Provider Last Name', headerTooltip: 'Rendering Provider Last Name' },
    { field: 'RenderingProviderNPI', headerName: 'Rendering Provider NPI', headerTooltip: 'Rendering Provider NPI' },
    { field: 'RenderingProviderTaxID', headerName: 'Rendering Provider Tax ID', headerTooltip: 'Rendering Provider Tax ID' },
    { field: 'RenderingProviderTaxonomyCode', headerName: 'Rendering Provider Taxonomy Code', headerTooltip: 'Rendering Provider Taxonomy Code' },
    { field: 'RiskAdjustableCPT', headerName: 'RA CPT', headerTooltip: 'Risk Adjustable CPT' },
    { field: 'PlaceOfService', headerName: 'PlaceOfService', headerTooltip: 'PlaceOfService' },
    { field: 'RCMPID', headerName: 'RCM PID', headerTooltip: 'RCM PID' },
    { field: 'BillableProviderNPI', headerName: 'Billable Provider NPI', headerTooltip: 'Billable Provider NPI' },
    { field: 'BillableProviderName', headerName: 'Billable Provider Name', headerTooltip: 'Billable Provider Name' },
    { field: 'PatientDeceasedDate', headerName: 'Patient Deceased Date', headerTooltip: 'Patient Deceased Date' },
    { field: 'MBI', headerName: 'MBI', headerTooltip: 'MBI' },
    { field: 'PatientPolicyID', headerName: 'Patient Policy ID', headerTooltip: 'Patient Policy ID' },
    { field: 'IcdOnClaim', headerName: 'ICD on Claim', headerTooltip: 'ICD on Claim' },
    { field: 'PatientOnMAO', headerName: 'Patient on MAO', headerTooltip: 'Patient on MAO', valueFormatter: this.booleanValue },
    { field: 'DxOnMAO', headerName: 'ICD on MAO', headerTooltip: 'ICD on MAO', valueFormatter: this.booleanValue },
    { field: 'MAOStatus', headerName: 'MAO04 Status', headerTooltip: 'MAO04 Status' },
    { field: 'CurrentDate', headerName: 'Current Date', headerTooltip: 'Current Date' },
    { field: 'ClaimID', headerName: 'Claim ID', headerTooltip: 'Claim ID' },
    { field: 'FacilityName', headerName: 'Facility Name', headerTooltip: 'Facility Name' },
    { field: 'ClaimNumber', headerName: 'Claim Number', headerTooltip: 'Claim Number' },
    { field: 'ClaimType', headerName: 'Claim Type', headerTooltip: 'Claim Type' },
    { field: 'TOBCode', headerName: 'Type of Bill', headerTooltip: 'Type of Bill' },
    { field: 'RevenueCode', headerName: 'Revenue Code', headerTooltip: 'Revenue Code' },
    { field: 'PayerSubmissionDeadline', headerName: 'Payer Submission Deadline', headerTooltip: 'Payer Submission Deadline' },
    { field: 'DaysInStatus', headerName: 'Days In Status', type: 'numericColumn', headerTooltip: 'Days In Status' },
    { field: 'MAOCount', headerName: 'MAO04 Count', headerTooltip: 'MAO04 Count', type: 'numericColumn' },

    this.asmRecordTypeColDef,
    { colId: 'edit', headerName: 'Edit', suppressColumnsToolPanel: true,
    pinned: 'right', minWidth: 68, maxWidth: 68, cellRenderer: 'editRenderer', sortable: false },
  ];

  defaultColDef: ColDef = {
    sortable: true,
    menuTabs: [],
    minWidth: 100,
    lockPinned: true,
  };

  defaultColumns = [
    'Status', 'Payer', 'EMRPID', 'AssignedTo', 'DateOfService', 
    'VisitID', 'ICDCODE', 'PreferredAction', 'RootCause', 'Notes'
  ];

  gridContext: any;

  rowData: any[] = [];
  selectedRows: DiagnosisEventItem[] = [];
  gridColumnConfig: ColumnConfigItem[] = [];

  form?: FormGroup;
  emrControl = new FormControl('');
  icd10Control = new FormControl('');
  mbiControl = new FormControl('');

  private subscriptions = new Subscription();
  private readonly destroyRef = inject(DestroyRef);
  private readonly injector = inject(Injector);

  query: DiagnosisEventQuery = new DiagnosisEventQuery();
  previousQuery: DiagnosisEventQuery = new DiagnosisEventQuery();
  selectedMenuOption: ListMenuOption = new ListMenuOption();

  asmFiltersOnly = signal<boolean>(false);
  hasStatusValue = signal<boolean>(false);
  serviceYearState = signal<number | null>(null);
  exportTemplateViewReady = signal<boolean>(false);

  selectedAsmPayer = signal<any[] | null>(null);
  exportTemplateDisabled = computed(() => (this.selectedAsmPayer()?.length ?? 0) === 0);
  rootCauseDisabled = computed(() => !this.hasStatusValue() || this.isAsmModeEnabled());
  showGenerateAsmTooltip = signal<boolean>(false);

  private isAsmModeEnabled() {
    return this.mode == 'oppty-list' && this.asmFiltersOnly();
  }

  @ViewChild(AgGridAngular) agGrid!: AgGridAngular;
  @ViewChild(ProgressAllocationUserComponent) userAllocationComp!: ProgressAllocationUserComponent;
  @ViewChild(PreferredActionSelectComponent) pActionComp!: PreferredActionSelectComponent;
  @ViewChild('payerSelect') payerComp!: PayerSelectComponent;
  @ViewChild(StatusSelectComponent) statusComp!: StatusSelectComponent;
  @ViewChild(StatusStateSelectComponent) statusStateComp!: StatusStateSelectComponent;
  @ViewChild(RootCauseSelectComponent) rootCauseComp!: RootCauseSelectComponent;
  @ViewChild('assignOpptyList') assignedComp!: UserSearchByPermissionComponent;
  @ViewChild(DosSelectComponent) dosComp!: DosSelectComponent;
  private _exportTemplateSelect?: FilterFieldSearchSelectComponent<FilterSelectItem>;
  @ViewChild('exportTemplate')
  set exportTemplateSelect(value: FilterFieldSearchSelectComponent<FilterSelectItem> | undefined) {
    this._exportTemplateSelect = value;
    this.exportTemplateViewReady.set(!!value);
  }
  get exportTemplateSelect(): FilterFieldSearchSelectComponent<FilterSelectItem> | undefined {
    return this._exportTemplateSelect;
  }
  @ViewChild('asmPayerSelect') asmPayerComp!: PayerSelectComponent;
  serviceYear?: number;
  filterForTargetedHCC?: boolean;
  private targetedHccValueBeforeAsm?: boolean;

  private syncTargetedHccToggleWithAsm(isAsmOnly: boolean) {
    if (isAsmOnly) {
      if (this.targetedHccValueBeforeAsm === undefined) {
        this.targetedHccValueBeforeAsm = this.appStore.filterForTargetedHCC();
      }

      this.appStore.setFilterForTargetedHCC(false);
      this.appStore.setTargetedHccToggleDisabled(true);
      return;
    }

    this.appStore.setTargetedHccToggleDisabled(false);

    if (this.targetedHccValueBeforeAsm !== undefined) {
      this.appStore.setFilterForTargetedHCC(this.targetedHccValueBeforeAsm);
      this.targetedHccValueBeforeAsm = undefined;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?: Event) {
    if (event)
      this.agGrid?.api?.sizeColumnsToFit();
  }

  readonly appStore = inject(AppStore);

  readonly opptyListStore = inject(OpportunityListStore);

  detailDefaultCol: ColDef = {
    sortable: false, 
    suppressMovable: true, 
    menuTabs: [], 
    minWidth: 100
  }
  
  gridOptions: GridOptions = {
    masterDetail: true,
    isRowMaster: (dataItem) => {
      return dataItem && dataItem.HasChildRecords;
    },
    detailCellRendererParams:
    {
      detailGridOptions: {
        context: {
          componentParent: this
        },
        defaultColDef: this.detailDefaultCol,
        components: {
          hccHyperlinkRenderer: HccHyperlinkRendererComponent
        },
        columnDefs: [
          {
            field: 'DxEventID',
            headerName: '',
            hide: true,
          },
          {
            field: 'ModelVersionID',
            headerName: '',
            hide: true,
          },
          { 
            field: 'Version', 
            headerName: 'Version', 
            headerTooltip: 'Version', 
          },
          { 
            field: 'HCC', 
            headerName: 'HCC', 
            headerTooltip: 'HCC',
            cellRenderer: 'hccHyperlinkRenderer',
          },
          {
            field: 'ParentHCC',
            headerName: 'Parent HCC',
            headerTooltip: 'Parent HCC',
          },
          {
            field: 'ParentValueOnMAO04',
            headerName: 'Parent HCC on MAO04',
            headerTooltip: 'Parent HCC on MAO04',
            valueFormatter: (params: ValueFormatterParams) => {
              return params.value > 0 ? params.value.toString() : '';
            }
          },
          {
            field: 'HCCOnMOR',
            headerName: 'HCC on MOR',
            headerTooltip: 'HCC on MOR',
          },
          {
            field: 'ParentValueOnMOR',
            headerName: 'Parent on MOR',
            headerTooltip: 'Parent on MOR',
            valueFormatter: (params: ValueFormatterParams) => {
              return params.value > 0 ? params.value.toString() : '';
            }
          },
          {
            field: 'HCCOnMAO04',
            headerName: 'HCC on MAO04',
            headerTooltip: 'HCC on MAO04',
          },
          {
            field: 'MORStatus',
            headerName: 'MOR Status',
            headerTooltip: 'MOR Status',
          }
        ],
      },
      getDetailRowData: (params: any) => {
        try {
          this.subscriptions.add(this.fetchDetailData(params.data.ID).subscribe((result) => {
            params.successCallback(result);
          }));
        } catch (err) {
          console.error('Error fetching detail data', err);
          params.successCallback([]);
        }
      },
      domLayout: 'autoHeight'
    },
    detailRowAutoHeight: true,
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private opptyService: DiagnosisEventService,
    private userService: UserService,
    private settingsService: SettingsService,
    private permissionService: PermissionService,
    private exportService: ExportService,
    private filterService: FieldFilterService,
    private templateService: TemplateService,
    private dialog: MatDialog,
    private clipboard: Clipboard,
    private cd: ChangeDetectorRef,
    private snackbar: MatSnackBar
  ) {

      this.gridContext = { componentParent: this };
      this.query.Metadata = new QueryMetadata();
      this.query.Metadata.Sort = new QuerySort();

      if(this.router.url.includes('diagnosis-event')) {
        this.mode = 'dx-list';
      }

      effect(() => {
        this.filterForTargetedHCC = this.appStore.filterForTargetedHCC();
      });

      effect(() => {
        if (this.isAsmModeEnabled()) {
          this.icd10Control?.disable({ emitEvent: false });
          this.emrControl?.disable({ emitEvent: false });
          this.mbiControl?.disable({ emitEvent: false });
        } else {
          this.icd10Control?.enable({ emitEvent: false });
          this.emrControl?.enable({ emitEvent: false });
          this.mbiControl?.enable({ emitEvent: false });
        }
      });
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      emr: this.emrControl,
      icd10: this.icd10Control,
      mbi: this.mbiControl
    });

    this.userService.currentUser$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(user => {
        this.currentUser = user;
      });

    this.settingsService.serviceYear
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
        if(result > -1) {
          this.serviceYear = result;
          this.serviceYearState.set(result);
          this.resetGridFromTemplate();
          
          // Re-evaluate form validity after reset by triggering statusChanges
          if (this.form) {
            this.form.updateValueAndValidity({ emitEvent: true });
          }
        }
      });
    
    this.paTypeIDs = this.mode == 'oppty-list' ? [PreferredActionType.Opportunity.valueOf()] 
    : [PreferredActionType.Opportunity.valueOf(), PreferredActionType.Validation.valueOf()];

    this.defaultChipSelection = this.route.snapshot.paramMap.get('qfilter') || '';
    this.defaultUser = this.route.snapshot.queryParamMap.get('user') || '';
    this.defaultPayer = this.route.snapshot.queryParamMap.get('payer') || '';

    if(this.defaultChipSelection) {

      if(this.mode == 'oppty-list') {
        const index = this.opptyFilterChips.findIndex(c => c.Name == this.defaultChipSelection);
        this.opptyFilterChips[index].Selected = true;
      }

      if(this.mode == 'dx-list') {
        const index = this.dxFilterChips.findIndex(c => c.Name == this.defaultChipSelection);
        this.dxFilterChips[index].Selected = true;
      }

      this.currentChipSelection = this.route.snapshot.paramMap.get('qfilter');
    }

  }

  ngAfterViewInit(): void {
    effect((onCleanup) => {
      const exportTemplate = this.exportTemplateSelect;
      const isAsmOnly = this.isAsmModeEnabled();
      const isTemplateReady = this.exportTemplateViewReady();
      const selectedPayers = this.selectedAsmPayer();
      const serviceYear = this.serviceYearState();

      if (!isTemplateReady || !exportTemplate) {
        return;
      }

      if (!isAsmOnly) {
        exportTemplate.control?.reset(null, { emitEvent: false });
        exportTemplate.control?.markAsPristine();
        exportTemplate.control?.markAsUntouched();
        exportTemplate.options = [];
        return;
      }

      if ((selectedPayers?.length ?? 0) !== 1 || !serviceYear) {
        exportTemplate.setToNone();
        exportTemplate.options = [];
        return;
      }

      const payerID = StringFormatter.FilterObjectToString('ID', selectedPayers ?? []);
      const startDate = new Date(`1/1/${serviceYear}`).toLocaleDateString();
      const endDate = new Date(`12/31/${serviceYear}`).toLocaleDateString();
      const previousTemplate = exportTemplate.control?.value as FilterSelectItem | null;

      const sub = this.filterService.getExportTemplatesByTypeAndPayer('1', payerID, startDate, endDate).subscribe(result => {
        exportTemplate.options = result ?? [];

        if (previousTemplate?.ID && previousTemplate.ID > 0) {
          const matchedTemplate = result?.find((t: FilterSelectItem) => t.ID === previousTemplate.ID);
          if (matchedTemplate) {
            exportTemplate.control?.setValue(matchedTemplate);
            return;
          }
        }

        // Default selection: only auto-select when there is exactly one option.
        if (result && result.length === 1) {
          exportTemplate.setFirstOption();
        } else {
          exportTemplate.control?.setValue(null);
        }
      });

      onCleanup(() => sub.unsubscribe());
    }, { injector: this.injector });

    if (this.form) {
      this.form.statusChanges
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(result => {
          if(result == 'INVALID') {
            this.formValid = false;
          }

          if(result == 'VALID') {
            this.formValid = true;
          }
        });
    }

    this.statusComp.control.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((values: FilterSelectItem[] | null) => {
        this.hasStatusValue.set((values?.length ?? 0) > 0);
      });

    this.hasStatusValue.set((this.statusComp.getValues()?.length ?? 0) > 0);

    this.permissionService.activeUserPermissions
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
        this.activeUserPerms = result;

        this.activeUserPerms.forEach(p => {
          switch(p.PermissionID) {
            case PermissionMap.ViewAndEditAllDxEvents:
              this.editAllActive = true;
              break;

            case PermissionMap.AssignOpportunities:
              this.assignToActive = true;
              this.agGrid?.api?.getStatusPanel<IAgAssignButton>('assign-btn')?.updateAssignToActive(this.assignToActive);
              break;

            case PermissionMap.ExportDiagnosisEvents:
              this.exportActive = true;
              this.agGrid?.api?.getStatusPanel<IAgExportButton>('export-btn')?.updateExportActive(this.exportActive);
              break;

            default:
              break;
          }
        });

      });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.syncTargetedHccToggleWithAsm(false);
  }

  //#region On Ready Event Functions

  filtersReadyCheck() {
    if(!this.isPreferredActionReady) {
      return;
    }

    if(!this.isPayerReady) {
      return;
    }

    if(!this.isRootCauseReady) {
      return;
    }

    if(!this.isStatusReady) {
      return;
    }

    if(!this.isStatusStateReady) {
      return;
    }

    if(!this.isAssignedReady) {
      return;
    }

    if(!this.isDosReady) {
      return;
    }

    if(!this.isGridReady) {
      return;
    }

    const isInitialLoad = (this.defaultChipSelection != '') || (this.defaultUser != '') || (this.defaultPayer != '');
    this.setFiltersByPreset(isInitialLoad);

  }

  onGridReady() {

    this.subscriptions.add(this.settingsService.getDxEventColumnConfig(this.mode).subscribe(result => {

      this.isGridReady = true;

      this.agGrid?.api?.sizeColumnsToFit();

      this.filtersReadyCheck();

      if(!result) {

        if(this.mode == 'oppty-list') {
          this.opptyColumnDefs.forEach(c => {
            if(!c.field || c.suppressColumnsToolPanel) {
              return;
            }
  
            this.agGrid?.api?.setColumnsVisible([c.field], this.defaultColumns.includes(c.field));
          });
        }

        if(this.mode == 'dx-list') {
          this.dxColumnDefs.forEach(c => {
            if(!c.field || c.suppressColumnsToolPanel) {
              return;
            }
  
            this.agGrid?.api?.setColumnsVisible([c.field], this.defaultColumns.includes(c.field));
          });
        }

      } else {
        this.updateColumnConfig(result);
      }

      this.agGrid?.api?.refreshToolPanel();
    }));

    const paginatorPageSizeSetting = this.mode == 'oppty-list' ? SettingsKeys.OPPTY_LIST_PAGE_SIZE : SettingsKeys.DX_LIST_PAGE_SIZE;
    this.subscriptions.add(this.settingsService.getPaginatorPageSize(paginatorPageSizeSetting).subscribe(result => {
      if(result == 0) {
        return;
      }

      this.agGrid?.api?.getStatusPanel<IAgPaginator>('ag-paginator')?.setPageSize(result);
    }));
  }

  onStatusStateReady(filterOptions: FilterSelectItem[]) {
    this.isStatusStateReady = true;
    const ids = filterOptions.map(o => o.ID);
    const isEndUserSelect = 0; // this is a filter, not a select that the end user is choosing from
    this.statusComp.getOptionData(ids, isEndUserSelect);

    this.filtersReadyCheck();
  }

  onStatusReady(filterOptions: FilterSelectItem[]) {
    this.isStatusReady = true;
    const ids = filterOptions.map(o => o.ID);
    this.rootCauseComp.getOptionData(ids);

    this.filtersReadyCheck();
  }

  //#endregion

  //#region AG Grid Functions

  updateColumnConfig(items: ColumnConfigItem[]) {
    this.gridColumnConfig = items;

    items.forEach((c, index) => {
      this.agGrid?.api?.setColumnsVisible([c.Name], c.Visible);
      this.agGrid?.api?.moveColumns([c.Name], index);
    });
  }

  setColumns(fields: TemplateConfigFieldItem[]) {
    const currentDefs = this.mode == 'oppty-list' ? _.cloneDeep(this.opptyColumnDefs) : _.cloneDeep(this.dxColumnDefs);
    const newDefs: ColDef[] = [];
    
    if(fields?.length > 0) {
      newDefs.push(this.expandColDef);
    }

    fields.forEach(item => {
      const foundDef = currentDefs?.find(d => d.field == item.Field);

      if(foundDef) {
        foundDef.headerName = item.Label;
        foundDef.suppressMovable = true;
        foundDef.hide = false;
        newDefs.push(foundDef);
      } else {
        const newCol: ColDef = {
          colId: item.FieldID === 1 ? item.Label : item.Field,
          headerName: item.Label,
          headerTooltip: item.Label,
          valueGetter: () => {return item.DefaultValue},
          hide: false,
          suppressMovable: true
        }
        newDefs.push(newCol);
      }
    });

    if(fields?.length > 0) {
      newDefs.push(this.asmRecordTypeColDef);
      newDefs.push(this.editColDef);
    }

    if (newDefs.length == 0) {
      currentDefs.forEach((def) => {
        const newDef = _.cloneDeep(def);
        if (newDef.field && !newDef.suppressColumnsToolPanel) {
          newDef.hide = this.gridColumnConfig.length == 0
            ? !this.defaultColumns.includes(newDef.field)
            : !this.gridColumnConfig.some(c => c.Name == newDef.field && c.Visible);
        }
        newDefs.push(newDef);
      });
    }
    this.agGrid?.api?.setGridOption("columnDefs", newDefs);
  }

  getServerSideDatasource(): IServerSideDatasource {
    return {
      getRows: (params) => {
        this.query.Metadata.PageSize = params.api?.paginationGetPageSize();
        this.query.Metadata.PageNumber = params.api?.paginationGetCurrentPage();

        const sortModel = params.request.sortModel;

        this.query.Metadata.Sort = new QuerySort();
        this.query.Metadata.Sort.Sort = sortModel.length > 0 ? sortModel[0].sort : null;
        this.query.Metadata.Sort.ColID = sortModel.length > 0 ? sortModel[0].colId : null;

        this.query.IsOpptyQuery = this.mode == 'oppty-list';

        this.subscriptions.add(this.opptyService.getDiagnosisEvents(this.query).subscribe(result => {
          // The response can arrive after the grid is destroyed (e.g. navigating away mid-request).
          if (params.api?.isDestroyed()) {
            return;
          }

          this.checkQueryChange();

          this.currentListSize = result.ListSize ?? (result.Events?.length ?? 0);
          this.allSamePreferredActionFromServer = result.AllSamePreferredAction ?? false;
          this.currentPageRows = [];
          params.api?.hideOverlay();

          params.success({
            rowData: result.Events ?? [],
            rowCount: this.currentListSize,
          });

          result.Events?.forEach(r => {
            if (r?.ID) {
              this.currentPageRows.push(r.ID.toString());
            }
          });

          if(this.currentListSize == 0) {
            params.api?.showNoRowsOverlay();
          }

          params.api?.sizeColumnsToFit();

          this.agGrid?.api?.getStatusPanel<IAgExportButton>('export-btn')?.updateExportDisabled((result.Events?.length ?? 0) > 0 ? false : true);
          this.agGrid?.api?.getStatusPanel<IAgRowSelectedCount>('row-selected-count')?.updateTotalCount(this.currentListSize);
          this.agGrid?.api?.getStatusPanel<IAgPaginator>('ag-paginator')?.goToCurrentPage();

          this.checkAllSelected();
        },
        error => {
          params.fail();
          this.snackbar.open("Error loading data: " + error.message, "Close", {duration: 4000});
        }));

      },
    };
  }

  getRowId: GetRowIdFunc = (params: GetRowIdParams) => {
    return String(params.data.ID);
  };

  resetGridOverlay() {
    this.agGrid?.api?.hideOverlay();
  }

  onGenerateGridData() {
    const isAsmOnly = this.isAsmModeEnabled();
    this.query.FilterForTargetedHCC = this.filterForTargetedHCC ?? false;
    this.query.EventTypeIDs = 
    this.mode == 'oppty-list' 
    ? DiagnosisEventType.Opportunity.toString() 
    : [DiagnosisEventType.Opportunity, DiagnosisEventType.Validation, DiagnosisEventType.Other].toString();

    const selectedTemplate = this.exportTemplateSelect?.control?.value ?? {} as FilterSelectItem;
    this.query.TemplateID = isAsmOnly ? (selectedTemplate?.ID || 0) : 0;
    // Template columns replace the saved column layout, so don't reapply it on top of them
    const shouldApplyColumnConfig = this.gridColumnConfig?.length > 0 && this.query.TemplateID <= 0;

    if (isAsmOnly) {
      this.applyAsmFiltersToQuery();
    } else {
      this.query.StateIDs = StringFormatter.FilterObjectToString('ID', this.statusStateComp.getValues());
      this.query.StatusIDs = StringFormatter.FilterObjectToString('ID', this.statusComp.getValues());
      this.query.RootCauseIDs = StringFormatter.FilterObjectToString('ID', this.rootCauseComp.getValues());
      this.query.PreferredActionIDs = StringFormatter.FilterObjectToString('ID', this.pActionComp.getValues() ?? []);
      this.query.PayerIDs = StringFormatter.FilterObjectToString('ID', this.payerComp.getValues());
      this.query.AssignedToIDs = StringFormatter.FilterObjectToString('user_guid', this.getAssignedUsers());
      this.query.EmrPID = this.emrControl?.value ?? '';
      this.query.IcdCodeID = this.icd10Control?.value ?? '';
      this.query.MBI = this.mbiControl?.value ?? '';

      const quarters: DateQuarter[] = this.dosComp.getValues();
      const quarterRanges: QueryDateRange[] = [];

      if(quarters.length > 0) {
        quarters.forEach(q => {
          const range = new QueryDateRange();
          range.StartDate = q.StartDate.toLocaleDateString();
          range.EndDate = q.EndDate.toLocaleDateString();
          quarterRanges.push(range);
        });
      } else {
        const range = new QueryDateRange();
        range.StartDate = new Date(`1/1/${this.serviceYear}`).toLocaleDateString();
        range.EndDate = new Date(`12/31/${this.serviceYear}`).toLocaleDateString();
        quarterRanges.push(range);
      }

      this.query.DateRanges = quarterRanges;
    }

    //Export Template Functionality
    if(isAsmOnly) {
      const templateID = selectedTemplate?.ID || 0;

      if(templateID <= 0) {
        this.resetTemplateGridState();
      } else {
        this.subscriptions.add(this.templateService.getTemplateConfigFieldItems(templateID).subscribe(fields => {
          if(fields) {
            this.setColumns(fields);
            this.agGrid?.api?.setSideBarVisible(false);
          }
        }));
      }
    }

    this.checkEnableTemplateFieldStatus();

    this.resetGridOverlay();

    if(this.isFirstGenerate || this.currentListSize == 0) {
      this.agGrid?.api?.setGridOption('serverSideDatasource', this.getServerSideDatasource());
      this.isFirstGenerate = false;
      if (shouldApplyColumnConfig) {
        this.updateColumnConfig(this.gridColumnConfig);
      }
      return;
    }

    this.agGrid?.api?.refreshServerSide({purge: true});
    this.agGrid?.api?.deselectAll();
    if (shouldApplyColumnConfig) {
      this.updateColumnConfig(this.gridColumnConfig);
    }
  }

  onGridColumnSelect(event: any) {
    if(event.source == "api") {
      return;
    }
    
    const gridCols = this.agGrid?.api?.getAllGridColumns();

    const columns: ColumnConfigItem[] = [];
    gridCols.forEach(c => {
      const colId = c.getColId();
      if(colId == SELECTION_COLUMN_ID || colId == 'edit' || colId == 'expand' || colId == 'ASMRecordType') {
        return;
      }

      const item = new ColumnConfigItem();
      item.Name = colId;
      item.Visible = c.isVisible();
      columns.push(item);

    });

    this.gridColumnConfig = columns;

    this.agGrid?.api?.sizeColumnsToFit();
    this.subscriptions.add(this.settingsService.updateDxEventColumnConfig(columns, this.mode).subscribe(()=>{
      //TODO
    }));
  }

  onGridRowSelected(event: RowSelectedEvent<DiagnosisEventItem>) {
    if(!event || !event.node) {
      return;
    }

    // RowNode.selected is no longer public in AG Grid 36; isSelected() is the supported accessor.
    const isSelected = event.node.isSelected() === true;

    if(this.selectedRows.length + 1 > this.batchEditLimit && isSelected) {
      this.agGrid?.api?.getRowNode(event.node.id)?.setSelected(false);
      this.snackbar.open("Max items selected", "Close", {duration: 4000});
      return;
    }

    this.updateSelectedRows(event.data, isSelected);

    this.checkAllSelected();

    const rowSelectedCountPanel = this.agGrid?.api?.getStatusPanel<IAgRowSelectedCount>('row-selected-count');
    rowSelectedCountPanel?.updateSelectedCount(this.selectedRows.length);

    const assignStatusPanel = this.agGrid?.api?.getStatusPanel<IAgAssignButton>('assign-btn');
    assignStatusPanel?.updateAssignDisabled(this.selectedRows?.length > 0 ? false : true);
  }

  checkAllSelected() {
    let all = true;
    this.currentPageRows.forEach(id => {
      const n = this.agGrid?.api?.getRowNode(id);
      if(!n?.isSelected()) {
        all = false;
        return;
      }
    });

    this.allSelected.next(all);
    this.allBatchEditEnabled = all;
  }

  onGridGetContextMenu(params: GetContextMenuItemsParams) {

    if(params?.column?.getColId() == 'edit') {
      return [];
    }

    if(params?.column?.getColId() == SELECTION_COLUMN_ID) {
      return [];
    }

    const result = [
      {
        name: 'Copy',
        action: () => {
          const value = params.context.componentParent.getColumnValue(params?.column?.getColId(), params.value);
          params.context.componentParent.clipboard.copy(value);
        },
        icon: '<span class="ag-icon ag-icon-copy"></span>'
      }
    ];

    return result;
  }

  onCellKeyDown(event: any) {
    const kbEvent:KeyboardEvent = event.event;
    if (kbEvent.ctrlKey && kbEvent.key === "c") {
      const value = this.getColumnValue(event?.column?.getColId(), event.value);
      if (value) {
        this.clipboard.copy(value);
      }
    }
  }

  onListItemEditClick(item: DiagnosisEventItem) {
    const stateIDs = this.statusStateComp.options.map(o => o.ID);
    
    const data = new EditOpptyDialogData();
    data.items = [item];
    data.statusStateIDs = stateIDs;
    data.mode = 'single';
    data.parent = this.mode;
    data.targeted = this.query.FilterForTargetedHCC ?? false;

    const dialogRef = this.dialog.open(EditOpptyDialogComponent, new EditOpptyDialogModel(data));

    this.subscriptions.add(dialogRef.afterClosed().subscribe(result => {
      if(result) {
        this.onGenerateGridData();
        this.userAllocationComp?.updateData();
        this.selectedRows = [];
        this.agGrid?.api?.getStatusPanel<IAgRowSelectedCount>('row-selected-count')?.updateSelectedCount(this.selectedRows.length);
      }
    }));
  }

  showsAsmRecordType(item?: DiagnosisEventItem): boolean {
    return !!item?.EnableEditASMType;
  }

  canEditAsmRecordType(item?: DiagnosisEventItem): boolean {
    return this.showsAsmRecordType(item) && !this.isAsmModeEnabled();
  }

  onAsmRecordTypeChanged(params: NewValueParams) {
    // null from the API is displayed as Add
    const oldValue = params.oldValue ?? 'A';
    const newValue = params.newValue ?? 'A';

    if (oldValue === newValue) {
      return;
    }

    // The proc sets Status to "Submit on ASM" (on Delete), sets the ASM record type, and clears Root Cause.
    // Re-query on success and failure so the grid always reflects the server state.
    this.subscriptions.add(this.opptyService.updateAsmRecordType({ DiagnosisEventID: params.data.ID, ASMRecordType: newValue }).subscribe(
      () => this.refreshAfterAsmUpdate(),
      error => {
        this.snackbar.open("Error updating ASM record type: " + error.message, "Close", {duration: 4000});
        this.refreshAfterAsmUpdate();
      }));
  }

  private refreshAfterAsmUpdate() {
    // Re-fetch in place rather than onGenerateGridData() so the last generated query, page, sort and selection are kept
    this.agGrid?.api?.refreshServerSide({ purge: false });
    this.userAllocationComp?.updateData();
  }

  onNoteCellClick(item: DiagnosisEventItem) {
    this.dialog.open(DiagnosisEventNotesDialogComponent, new DiagnosisEventNotesDialogModel(item));
  }

  onPaginatorPageSizeChange(pageSize: number) {
    this.currentPageRows = [];
    this.selectedRows = [];
    this.agGrid?.api?.deselectAll();
    this.agGrid?.api?.getStatusPanel<IAgRowSelectedCount>('row-selected-count')?.updateSelectedCount(this.selectedRows.length);
    const paginatorPageSizeSetting = this.mode == 'oppty-list' ? SettingsKeys.OPPTY_LIST_PAGE_SIZE : SettingsKeys.DX_LIST_PAGE_SIZE;
    this.subscriptions.add(this.settingsService.updatePaginatorPageSize(pageSize, paginatorPageSizeSetting).subscribe(() => {
      //TODO
    }));
  }

  onSelectionChanged(event: SelectionChangedEvent) {
    return event;
    //this.allSelected = (event.source == 'uiSelectAll' && !this.allSelected);
  }

  //#endregion

  //#region On Change Event Functions

  onChipFilterChange(chip: any) {
    if(!chip) {
      return;
    }

    if(chip.Name == this.currentChipSelection) {
      return;
    }

    if(this.canQuickFilterUnselect) {
      this.canQuickFilterUnselect = false;
    }

    if(this.mode == 'oppty-list') {
      const prevIndex = this.opptyFilterChips.findIndex(c => c.Name == this.currentChipSelection);

      if(prevIndex > -1) {
        this.opptyFilterChips[prevIndex].Selected = false;
      }
    }

    if(this.mode == 'dx-list') {
      const prevIndex = this.dxFilterChips.findIndex(c => c.Name == this.currentChipSelection);

      if(prevIndex > -1) {
        this.dxFilterChips[prevIndex].Selected = false;
      }
    }

    chip.Selected = true;

    this.currentChipSelection = chip.Name;

    this.setFiltersByPreset();
    
  }

  onAsmFiltersOnlyChange(value: boolean) {
    if (this.mode != 'oppty-list') {
      this.resetAsmFiltersToDefault();
      this.syncTargetedHccToggleWithAsm(false);
      this.asmFiltersOnly.set(false);
      this.showGenerateAsmTooltip.set(false);
      return;
    }

    this.resetAsmFiltersToDefault();
    this.syncTargetedHccToggleWithAsm(value);
    this.asmFiltersOnly.set(value);
    this.showGenerateAsmTooltip.set(value);

    // ASM Add/Delete is displayed but disabled during the Generate ASM workflow
    if (value) {
      this.agGrid?.api?.stopEditing(true);
    }
    this.agGrid?.api?.refreshCells({ columns: ['ASMRecordType'], force: true });
  }

  isGenerateDisabled() {
    if (!this.form) {
      return true;
    }

    if (this.form.invalid) {
      return true;
    }

    if (!this.isAsmModeEnabled()) {
      return false;
    }

    const asmPayerControl = this.asmPayerComp?.control;
    if (asmPayerControl && !asmPayerControl.disabled && asmPayerControl.invalid) {
      return true;
    }

    const exportTemplateControl = this.exportTemplateSelect?.control;
    if (exportTemplateControl && !exportTemplateControl.disabled && exportTemplateControl.invalid) {
      return true;
    }

    return false;
  }

  setSelectedAsmPayer(value: any) {
    const previousPayerKey = this.getAsmPayerSelectionKey(this.selectedAsmPayer());
    const selectedPayers = Array.isArray(value) ? value : (value ? [value] : []);
    const nextPayerKey = this.getAsmPayerSelectionKey(selectedPayers);

    if (previousPayerKey !== nextPayerKey) {
      const exportTemplate = this.exportTemplateSelect;
      if (exportTemplate) {
        exportTemplate.setToNone();
        exportTemplate.options = [];
      }
    }

    this.selectedAsmPayer.set(selectedPayers.length > 0 ? selectedPayers : null);
  }

  private getAsmPayerSelectionKey(payers: unknown[] | null | undefined): string {
    return (payers ?? [])
      .map(p => (p as { ID?: number | string } | null | undefined)?.ID)
      .filter(id => id !== undefined && id !== null)
      .sort((a, b) => Number(a) - Number(b))
      .join(',');
  }

  private resetAsmFiltersToDefault() {
    this.selectedAsmPayer.set(null);

    const asmPayerControl = this.asmPayerComp?.control;
    if (asmPayerControl) {
      asmPayerControl.reset(null, { emitEvent: false });
      asmPayerControl.markAsPristine();
      asmPayerControl.markAsUntouched();
    }

    const exportTemplate = this.exportTemplateSelect;
    if (exportTemplate) {
      exportTemplate.control?.setValue(null, { emitEvent: false });
      exportTemplate.control?.markAsPristine();
      exportTemplate.control?.markAsUntouched();
      exportTemplate.options = [];
    }
  }

  onQueryFilterChange(value: any) {
    if (value === undefined) {
      return;
    }

    if(this.canQuickFilterUnselect) {
      //TODO

      //TEMP FUNCTIONALITY
      this.currentChipSelection = '';

      if(this.mode == 'oppty-list') {
        this.opptyFilterChips.forEach(c => c.Selected = false);
      }
  
      if(this.mode == 'dx-list') {
        this.dxFilterChips.forEach(c => c.Selected = false);
      }
      
      this.canQuickFilterUnselect = false;
    }
  }

  onStatusStatesSelected(items: FilterSelectItem[]) {
    this.statusComp.control.reset();
    this.statusComp.control.markAsTouched();
    this.statusComp.setValues([], items.map(i => i.ID));

    // Root causes link to statuses, not status states, so filter by the statuses now available
    this.rootCauseComp.control.reset();
    this.rootCauseComp.setValues([], this.statusComp.filteredOptions.map(o => o.ID));
  }

  onStatusSelected(items: FilterSelectItem[]) {
    this.hasStatusValue.set(items && items.length > 0);
    this.rootCauseComp.control.reset();
    const sids = items.map(i => i.ID);
    this.rootCauseComp.setValues([], sids);
  }

  onSelectedMenuOption(option: ListMenuOption) {
    if(!option) {
      return;
    }

    if(option.ID == this.selectedMenuOption.ID) {
      this.sideMenuCollapsed = !this.sideMenuCollapsed ? true : false;
      return;
    }

    this.sideMenuCollapsed = true;
    this.selectedMenuOption = option;
  }

  checkEnableTemplateFieldStatus() {
    // Export templates are ASM-only now.
    // When ASM mode is off, ensure template-driven grid state is cleared.
    if (!this.isAsmModeEnabled()) {
      if (this.exportTemplateSelect) {
        this.exportTemplateSelect.setToNone();
        this.exportTemplateSelect.options = [];
      }
      this.resetTemplateGridState();
    }
  }

  resetTemplateGridState() {
    this.setColumns([]);
    this.updateColumnConfig(this.gridColumnConfig);
    this.agGrid?.api?.setSideBarVisible(true);
  }

  resetGridFromTemplate() {
    this.exportTemplateSelect?.setToNone();
    this.resetTemplateGridState();
    this.syncTargetedHccToggleWithAsm(false);
    this.asmFiltersOnly.set(false);
    this.showGenerateAsmTooltip.set(false);
    this.resetAsmFiltersToDefault();
  }

  //#endregion

  //#region On Button Actions

  onAssignButtonClick() {
    const assignStatusPanel = this.agGrid?.api?.getStatusPanel<IAgAssignButton>('assign-btn');
    const editStatusPanel = this.agGrid?.api?.getStatusPanel<IAgOpptyEditButton>('edit-btn');
    assignStatusPanel?.updateAssignDisabled(true);
    editStatusPanel?.updateDisabled(true);

    const data = {
      items: this.selectedRows, 
      parent: this.mode, 
      allEnabled: this.allBatchEditEnabled, 
      queryResultsCount: this.currentListSize, 
      query: this.allBatchEditEnabled ? this.query : null
    };

    const dialogRef = this.dialog.open(AssignOpptyDialogComponent, new AssignOpptyDialogModel(data));

    this.subscriptions.add(dialogRef.afterClosed().subscribe(result => {
      if(result) {
        this.selectedRows = [];
        this.agGrid?.api?.getStatusPanel<IAgRowSelectedCount>('row-selected-count')?.updateSelectedCount(this.selectedRows.length);
        this.onGenerateGridData();
        this.userAllocationComp?.updateData();
      }

      assignStatusPanel?.updateAssignDisabled(this.selectedRows?.length > 0 ? false : true);

      editStatusPanel?.updateDisabled(this.computeBatchEditDisabled());
    }));
  }

  onExportClick() {
    
    if (this.isAsmModeEnabled()) {
      const now = new Date();
      //open dialog for asm file generation and submission
      const payerID = this.getAsmPayerIdFromQuery();
      const templateID = this.query.TemplateID || 0;
      const asmStatusId = this.statusComp.options.find(s => s.Description == 'ASM Submitted (Pending MAO)')?.ID ?? 0;
      const data = {
        recordCount: this.currentListSize,
        userFirstInitial: this.currentUser?.firstName.charAt(0),
        userLastName: this.currentUser?.lastName,
        exportedDateTime: `${LocalDateTimeHelper.getCurrentDateString(now).toLowerCase()}`,
        payerID: payerID,
        serviceYear: this.serviceYear,
        templateID: templateID
      };
      const dialogRef = this.dialog.open<AsmFileGenerationAndSubmissionComponent, AsmFileGenerationAndSubmissionModel, any>(AsmFileGenerationAndSubmissionComponent, {...ASM_FILE_GEN_AND_SUB_CONFIG, data: data as AsmFileGenerationAndSubmissionModel});
      //subscribe to closure, export if needed
      this.subscriptions.add(dialogRef.afterClosed().subscribe((result: { toUpdateStatus: boolean; notes: string[] } | null) => {
        if (result && result.notes && result.notes.length > 0 && result.notes[0] != '') {
          const newStatusId: number = result.toUpdateStatus ? asmStatusId : 0;
          const notes = result.notes.join('\n');
          const templateName = this.exportTemplateSelect?.options.find(t => t.ID == this.query.TemplateID)?.Description || '';
          const request = new AsmFileUpdateRequest();
          request.NewStatusID = newStatusId;
          request.Notes = notes;
          request.Datetime = data.exportedDateTime;
          request.Query = this.query;
          request.Source = this.mode == 'oppty-list' ? 'Opportunity' : 'DxEvents';
          request.TemplateName = templateName;
          /* ASM Upload handler in API has its own log entries, this flag is solely for non-ASM uploads */
          this.subscriptions.add(
            this.export(request)
              .subscribe(result => {
                this.exportResultHandler(result);
              })
          );
        } else if (result) {
          this.subscriptions.add(this.export(undefined).subscribe(result => {
            this.exportResultHandler(result);
          }));
        }
      }));
    } else {
      this.subscriptions.add(this.export().subscribe(result => {
        this.exportResultHandler(result);
      }));
    }
  }

  export(asmRequest?: AsmFileUpdateRequest) {
    const filterValues = this.getFilterValues();

    const exportTemplateID = this.isAsmModeEnabled() ? (this.query.TemplateID || 0) : 0;

    const sourceComp = this.mode == 'oppty-list' ? 'Opportunity' : 'DxEvents';
    const serviceYear = this.isAsmModeEnabled() ? this.serviceYear : undefined;
    return this.exportService.exportDiagnosisEvents(this.query, sourceComp, "excel", exportTemplateID, filterValues, asmRequest, serviceYear);
  }

  private getAsmPayerIdFromQuery(): number {
    const payerId = (this.query.PayerIDs ?? '').trim();
    if (!payerId) {
      return 0;
    }

    const parsedPayerId = Number(payerId);
    return Number.isFinite(parsedPayerId) ? parsedPayerId : 0;
  }

  private getAsmPayerAbbreviationsFromQuery(): string {
    const payerId = this.getAsmPayerIdFromQuery();
    if (payerId <= 0) {
      return '';
    }

    const payerOptions = this.asmPayerComp?.options ?? [];
    const queryPayer = payerOptions.find(p => Number(p?.ID) === payerId);
    return queryPayer?.Abbreviation ?? '';
  }

  private getFilterDescriptionsFromQuery(idsCsv: string | null | undefined, options: FilterSelectItem[] | null | undefined): string {
    const ids = (idsCsv ?? '')
      .split(',')
      .map(id => Number(id.trim()))
      .filter(id => Number.isFinite(id));

    if (ids.length === 0 || !options || options.length === 0) {
      return '';
    }

    const matched = ids
      .map(id => options.find(option => option?.ID === id))
      .filter((option): option is FilterSelectItem => !!option);

    return StringFormatter.FilterObjectToString('Description', matched);
  }

  private getPayerAbbreviationsFromQuery(idsCsv: string | null | undefined, options: { ID?: number | string; Abbreviation?: string }[] | null | undefined): string {
    const ids = (idsCsv ?? '')
      .split(',')
      .map(id => Number(id.trim()))
      .filter(id => Number.isFinite(id));

    if (ids.length === 0 || !options || options.length === 0) {
      return '';
    }

    const matched = ids
      .map(id => options.find(option => Number(option?.ID) === id))
      .filter((option): option is { ID?: number | string; Abbreviation?: string } => !!option);

    return matched
      .map(option => option.Abbreviation ?? '')
      .filter(abbreviation => abbreviation.length > 0)
      .join(', ');
  }

  private getAssignedFromQuery(): string {
    const assignedIds = (this.query.AssignedToIDs ?? '')
      .split(',')
      .map(id => id.trim())
      .filter(id => id.length > 0);

    if (assignedIds.length === 0) {
      return '';
    }

    const users = this.assignedComp?.userOptions
      ?.map(option => option.user)
      ?.filter(user => {
        const userId = user?.user_guid || user?.uid || user?.user_id;
        return !!userId && assignedIds.includes(userId);
      }) ?? [];

    return StringFormatter.UsersFullNameString(users);
  }

  exportResultHandler(result: { AsmExportEnqueued?: boolean } | null) {
    if (!result?.AsmExportEnqueued) {
      const message = [
        `Requested records are being exported and will be available for download from the My Exports page within the User menu.`,
        `Dependent upon the data request, it may be several minutes before the export is available.`
      ];

      const dialogRef = this.dialog.open(OkDialogComponent, new OkDialogModel(
        'Export Requested',
        message
      ));

      this.subscriptions.add(
        dialogRef.afterClosed().subscribe(() => {
          //this.onGenerateGridData();
        })
      );
    } else {
      const dialogRef = this.dialog.open(OkDialogComponent, new OkDialogModel(
        "ASM File Export",
        [
          `The ASM file is available for downloading from the My Exports page within the User menu.`,
          `Administrators may also view the file status and download the file from the ASM Files page within Settings.`
        ]
      ));

      this.subscriptions.add(
        dialogRef.afterClosed().subscribe(() => {
          //this.onGenerateGridData();
        })
      );
    }
  }

  private getAsmSelections() {
    const state = this.statusStateComp.options.find(o => o.Description == 'Open');
    const status = this.statusComp.options.find(o => o.Description == 'Submit on ASM');
    const preferredAction = this.pActionComp.options.find(o => o.Description === 'ASM');
    const payers = this.asmPayerComp?.getValues() ?? [];

    const dateRanges: QueryDateRange[] = [
      {
        StartDate: `1/1/${this.serviceYear}`,
        EndDate: `3/31/${this.serviceYear}`
      },
      {
        StartDate: `4/1/${this.serviceYear}`,
        EndDate: `6/30/${this.serviceYear}`
      },
      {
        StartDate: `7/1/${this.serviceYear}`,
        EndDate: `9/30/${this.serviceYear}`
      },
      {
        StartDate: `10/1/${this.serviceYear}`,
        EndDate: `12/31/${this.serviceYear}`
      }
    ];

    return {
      stateItems: state ? [state] : [],
      statusItems: status ? [status] : [],
      preferredActionItems: preferredAction ? [preferredAction] : [],
      payerItems: payers,
      dateRanges
    };
  }

  private applyAsmFiltersToQuery() {
    const asmSelections = this.getAsmSelections();

    this.query.StateIDs = StringFormatter.FilterObjectToString('ID', asmSelections.stateItems);
    this.query.StatusIDs = StringFormatter.FilterObjectToString('ID', asmSelections.statusItems);
    this.query.RootCauseIDs = '';
    this.query.PreferredActionIDs = StringFormatter.FilterObjectToString('ID', asmSelections.preferredActionItems);
    this.query.PayerIDs = StringFormatter.FilterObjectToString('ID', asmSelections.payerItems);
    this.query.AssignedToIDs = this.editAllActive
      ? ''
      : StringFormatter.FilterObjectToString('user_guid', this.getAssignedUsers());
    this.query.EmrPID = '';
    this.query.MBI = '';
    this.query.IcdCodeID = '';
    this.query.DateRanges = asmSelections.dateRanges;
  }

  private getAssignedUsers(): User[] {
    const assignedUsers = this.assignedComp?.getValues() ?? [];

    if(assignedUsers.length > 0) {
      return assignedUsers;
    }

    if(!this.editAllActive && this.currentUser) {
      const currentUserID = this.currentUser.user_guid || this.currentUser.uid || this.currentUser.user_id;

      if(currentUserID) {
        return [{ ...this.currentUser, user_guid: currentUserID } as User];
      }
    }

    return [];
  }

  getAsmOnlyFilterValues() {
    const asmSelections = this.getAsmSelections();
    const filterValues = new DiagnosisEventFilterValues();
    const stateFromQuery = this.getFilterDescriptionsFromQuery(this.query.StateIDs, this.statusStateComp.options);
    const statusFromQuery = this.getFilterDescriptionsFromQuery(this.query.StatusIDs, this.statusComp.options);
    const preferredActionFromQuery = this.getFilterDescriptionsFromQuery(this.query.PreferredActionIDs, this.pActionComp.options);
    const payerFromQuery = this.getAsmPayerAbbreviationsFromQuery();
    const assignedFromQuery = this.getAssignedFromQuery();
    filterValues.State = stateFromQuery || StringFormatter.FilterObjectToString('Description', asmSelections.stateItems);
    filterValues.Status = statusFromQuery || StringFormatter.FilterObjectToString('Description', asmSelections.statusItems);
    filterValues.RootCause = '';
    filterValues.PreferredAction = preferredActionFromQuery || StringFormatter.FilterObjectToString('Description', asmSelections.preferredActionItems);
    filterValues.Payer = payerFromQuery || StringFormatter.FilterObjectToString('Abbreviation', asmSelections.payerItems);
    filterValues.Assigned = assignedFromQuery || (this.editAllActive ? '' : StringFormatter.UsersFullNameString(this.getAssignedUsers()));
    filterValues.EMRPID = '';
    filterValues.MBI = '';
    filterValues.ICD10 = '';
    filterValues.DateRanges = this.query.DateRanges ?? asmSelections.dateRanges;

    return filterValues;
  }

  getNonAsmFilterValues() {
    const filterValues = new DiagnosisEventFilterValues();
    const stateFromQuery = this.getFilterDescriptionsFromQuery(this.query.StateIDs, this.statusStateComp.options);
    const statusFromQuery = this.getFilterDescriptionsFromQuery(this.query.StatusIDs, this.statusComp.options);
    const rootCauseFromQuery = this.getFilterDescriptionsFromQuery(this.query.RootCauseIDs, this.rootCauseComp.options);
    const preferredActionFromQuery = this.getFilterDescriptionsFromQuery(this.query.PreferredActionIDs, this.pActionComp.options);
    const payerFromQuery = this.getPayerAbbreviationsFromQuery(this.query.PayerIDs, this.payerComp.options);
    const assignedFromQuery = this.getAssignedFromQuery();

    filterValues.State = stateFromQuery || StringFormatter.FilterObjectToString('Description', this.statusStateComp.getValues() ?? []);
    filterValues.Status = statusFromQuery || StringFormatter.FilterObjectToString('Description', this.statusComp.getValues() ?? []);
    filterValues.RootCause = rootCauseFromQuery || StringFormatter.FilterObjectToString('Description', this.rootCauseComp.getValues() ?? []);
    filterValues.PreferredAction = preferredActionFromQuery || StringFormatter.FilterObjectToString('Description', this.pActionComp.getValues() ?? []);
    filterValues.Payer = payerFromQuery || StringFormatter.FilterObjectToString('Abbreviation', this.payerComp.getValues());
    filterValues.Assigned = assignedFromQuery || StringFormatter.UsersFullNameString(this.getAssignedUsers());
    filterValues.EMRPID = this.query.EmrPID ?? '';
    filterValues.MBI = this.query.MBI ?? '';
    filterValues.ICD10 = this.query.IcdCodeID ?? '';
    filterValues.DateRanges = this.query.DateRanges ?? [];

    return filterValues;
  }

  getFilterValues() {
    if (this.isAsmModeEnabled()) {
      return this.getAsmOnlyFilterValues();
    } else {
      return this.getNonAsmFilterValues();
    }
  }

  onBatchEditClick() {
    const assignStatusPanel = this.agGrid?.api?.getStatusPanel<IAgAssignButton>('assign-btn');
    const editStatusPanel = this.agGrid?.api?.getStatusPanel<IAgOpptyEditButton>('edit-btn');
    assignStatusPanel?.updateAssignDisabled(true);
    editStatusPanel?.updateDisabled(true);

    const stateIDs = this.statusStateComp.options.map(o => o.ID);

    const selectedTemplate = this.exportTemplateSelect?.control?.value ?? {} as FilterSelectItem;
    const templateEnabled = this.isAsmModeEnabled() ? (selectedTemplate.ID > 0) : false;
    
    const data = new EditOpptyDialogData();
    data.items = this.selectedRows;
    data.statusStateIDs = stateIDs;
    data.mode = 'batch';
    data.parent = this.mode;
    data.allEnabled = this.allBatchEditEnabled;
    data.allSamePreferredActionFromServer = this.allSamePreferredActionFromServer;
    data.query = (this.allBatchEditEnabled && this.allSamePreferredActionFromServer) ? this.query : undefined;
    data.queryResultCount = this.currentListSize;
    data.exportEnabled = templateEnabled;
    data.targeted = this.query.FilterForTargetedHCC ?? false;

    const dialogRef = this.dialog.open(EditOpptyDialogComponent, new EditOpptyDialogModel(data));

    this.subscriptions.add(dialogRef.afterClosed().subscribe(result => {
      if(result) {
        this.selectedRows = [];
        this.agGrid?.api?.getStatusPanel<IAgRowSelectedCount>('row-selected-count')?.updateSelectedCount(this.selectedRows.length);
        this.onGenerateGridData();
        this.userAllocationComp?.updateData();
      }

      if(result == 'export') {
        this.onExportClick();
      }

      assignStatusPanel?.updateAssignDisabled(this.selectedRows?.length > 0 ? false : true);

      editStatusPanel?.updateDisabled(this.computeBatchEditDisabled());
    }));
  }

  //#endregion

  setFiltersByPreset(isInitialLoad = false) {
    this.form?.reset();

    const statusStateValue = this.statusStateComp.options.find(o => o.Description == 'Open');
    const newStatusValue = this.statusComp.options.find(o => o.Description == 'New');
    let statusValues: FilterSelectItem[] = [];
    if (this.mode == 'oppty-list' && statusStateValue && newStatusValue) {
      const openStatusValues = this.statusComp.options.filter(o => o.LinkAssociations.includes(statusStateValue.ID));

      switch(this.currentChipSelection) {
        case "Master": {
          statusValues = [];
          break;
        }
        case "99499": {
          const post99499StatusValue = this.statusComp?.options?.find(o => o.Description === 'Post 99499');
          if (post99499StatusValue && newStatusValue) {
            statusValues = [newStatusValue, post99499StatusValue];
          } else {
            statusValues = [newStatusValue];
          }
          break;
        }
        case "ASM": {
          const submitOnAsmStatusValue = this.statusComp?.options?.find(o => o.Description === 'Submit on ASM');
          if (submitOnAsmStatusValue) {
            statusValues = [submitOnAsmStatusValue];
          } else {
            statusValues = [newStatusValue];
          }
          break;
        }
        default:
          statusValues = [newStatusValue];
          break;
      }

      const rootCauseStatusIds = (statusValues.length > 0 ? statusValues : openStatusValues).map(o => o.ID);

      this.statusStateComp.setValues([statusStateValue]);
      this.statusComp.setValues(statusValues ?? [], [statusStateValue.ID]);
      this.rootCauseComp.setValues([], rootCauseStatusIds);
    } else if (this.mode == 'dx-list') {
      const statusStateClosedValue = this.statusStateComp.options.find(o => o.Description === 'Closed');
      const statusNonActionableUDValue = this.statusComp.options.find(o => o.Description === 'Non-Actionable (User Defined)');
      const statusNonActionableSysValue = this.statusComp.options.find(o => o.Description === 'Non-Actionable (System)');
      const statusValidationValue = this.statusComp.options.find(o => o.Description === 'Validation');

      switch(this.currentChipSelection) {

        case "Payer Validation":
          if (statusStateClosedValue && statusValidationValue) {
            this.statusStateComp.setValues([statusStateClosedValue]);
            this.statusComp.setValues([statusValidationValue], [statusStateClosedValue.ID]);
            this.rootCauseComp.setValues([], [statusValidationValue.ID]);
          }

          break;

        case "Non-Actionable":
          if (statusStateClosedValue && statusNonActionableUDValue && statusNonActionableSysValue) {
            this.statusStateComp.setValues([statusStateClosedValue]);
            this.statusComp.setValues([statusNonActionableUDValue, statusNonActionableSysValue], [statusStateClosedValue.ID]);
            this.rootCauseComp.setValues([], [statusNonActionableUDValue.ID, statusNonActionableSysValue.ID]);
          }

          break;

        default:
          this.statusStateComp.setValues([]);
          this.statusComp.setValues([]);
          this.rootCauseComp.setValues([]);

          break;
      }
    }

    const paItem = this.pActionComp.options.find(o => o.Description == this.currentChipSelection);
    this.pActionComp.setValues( paItem ? [paItem] : []);
    this.emrControl.setValue('');
    this.icd10Control.setValue('');
    this.mbiControl.setValue('');
    this.dosComp.setValues([]);

    const foundUser = this.assignedComp.userOptions.find(u => u.user.given_name + ' ' + u.user.family_name == this.defaultUser);
    this.assignedComp.setSelectedValues(foundUser ? [foundUser.user] : []);

    const foundPayer = this.payerComp.options.find(p => p.Name == this.defaultPayer);
    this.payerComp.setSelectedValues(foundPayer ? [foundPayer] : []);

    if(isInitialLoad) {
      this.onGenerateGridData();
      return;
    }

    this.checkQueryChange();

    setTimeout(() => {
      this.canQuickFilterUnselect = true;
    }, 500);
  }

  tooltipValue(item: any) {
    if(!item.value) {
      return;
    }

    return item.value;
  }

  filterTooltipValue(item: any) {
    if(!item.value) {
      return;
    }

    return item.value.Description;
  }

  assignedUserValue(item: any) {
    if(!item.value) {
      return '';
    }

    if(item.value.UserID == 0) {
      return '';
    }

    const firstName = item.value.FirstName;
    if(!firstName) {
      return '';
    }

    return firstName[0] + '. ' + item.value.LastName;
  }

  assingedUserTooltip(item: any) {
    if(!item.value) {
      return;
    }

    if(item.value.UserID == 0) {
      return;
    }


    return item.value.FirstName + ' ' + item.value.LastName;
  }

  payerValue(item: any) {
    if(!item.value) {
      return null;
    }

    return item.value.Abbreviation;
  }

  filterOptionValue(item: any) {
    if(!item.value) {
      return null;
    }

    return item.value.Description;
  }

  payerTooltip(item: any) {
    if(!item.value) {
      return;
    }

    return item.value.Name;
  }

  booleanValue(item: any) {
    if (item.value == null) {
      return "";
    }

    if (!item.value) {
      return "No";
    }

    return "Yes";
  }

  dateTimeToLocalValue(item: any) {
    if(!item) {
      return;
    }

    return formatDate(new Date(item.value + ' UTC'), 'MM/dd/yyyy', 'en');
  }

  computeBatchEditDisabled(): boolean {
    if (this.selectedRows.length === 0) return true;

    const hasUnassigned = this.selectedRows.some(i => i.AssignedTo == null);
    if (hasUnassigned) return true;

    const allSamePreferredAction = this.allSamePreferredActionFromServer ||
      new Set(this.selectedRows.map(r => r.PreferredAction?.ID)).size === 1;

    return !allSamePreferredAction;
  }

  updateSelectedRows(item: DiagnosisEventItem, isAdd: boolean) {

    const found = this.selectedRows.find(o => o.ID == item.ID);

    if(isAdd && !found) {
      this.selectedRows.push(item);
    }

    if(!isAdd && found) {
      this.selectedRows = this.selectedRows.filter(o => o.ID != found.ID);
    }

    this.agGrid?.api?.getStatusPanel<IAgOpptyEditButton>('edit-btn')?.updateDisabled(this.computeBatchEditDisabled());
  }

  getColumnValue(fieldName: string, value: any) {
    if(!value) {
      return null;
    }

    let result = '';

    switch(fieldName) {
      case "StatusState":
      case "Status":
      case "RootCause":
      case "PreferredAction":
        result = value.Description;
        break;

      case "AssignedTo":
      case "LastModifiedBy":
        result = value.FirstName + ' ' + value.LastName;
        break;

      case "Payer":
        result = value.Name;
        break;

      case "ASMRecordType":
        result = this.asmRecordTypeOptions[value] ?? '';
        break;

      default:
        result = value;
        break;
    }

    return result;
  }

  checkQueryChange() {
    if(!Comparitors.DiagnosisEventQueryEquals(this.query, this.previousQuery)) {
      this.previousQuery = structuredClone(this.query);
      this.agGrid?.api?.deselectAll();
      this.selectedRows = [];
      this.allSamePreferredActionFromServer = false;
      this.agGrid?.api?.getStatusPanel<IAgRowSelectedCount>('row-selected-count')?.updateSelectedCount(0);
      this.agGrid?.api?.getStatusPanel<IAgOpptyEditButton>('edit-btn')?.updateDisabled(true);
      this.agGrid?.api?.getStatusPanel<IAgPaginator>('ag-paginator')?.resetPaginator();
    }
  }

  fetchDetailData(masterId: number) {
    return this.opptyService.getDxEventDetails(masterId);
  }

  onDetailRowClicked(event: RowClickedEvent) {
    this.opptyListStore.getDxEventHccDetails(event?.data?.HCC, event?.data?.DxEventID, event?.data?.ModelVersionID);
  }
}
